import { CurrentConvertedCalendars } from './google_events'

export function thirdPartyCalendarIdToPrimaryEmail(id: string): string {
  return (
    CurrentConvertedCalendars.find((calendar) => calendar.id === id)
      ?.primaryCalendarEmail || ''
  )
}
